<template>
    <div>
        <my-header :activeMenu="'news-index'"></my-header>
        <div class="news_main">
            <div class="banner">
                <img src="https://cdn.kuailework.com/images/officialWebsite/banner/news@2x.png"/>
            </div>
            <div class="menu">
                <div :class="['menu_item',categoryName=='集团动态'?'active':'']" @click="tabCurrent('集团动态')">
                    <img src="@/assets/img_jtdt.png"/>
                    <p>集团动态</p>
                </div>
                <div :class="['menu_item',categoryName=='投教基地'?'active':'']" @click="tabCurrent('投教基地')">
                    <img src="@/assets/img_tjjd.png"/>
                    <p>投教基地</p>
                </div>
            </div>
            <ul class="news_ul">
                <li v-for="item in list" :key="item.id" @click="toDetail(item.id)">
                    <div class="news_img_box">
                        <img v-if="item.sImg" :src="item.sImg"/>
                    </div>
                    <div class="targetSearchKey">{{item.title}}</div>
                    <div class="discription">{{item.discription}}</div>
                </li>
            </ul>
            <div class="pagenation_box">
                <pagenation @current-change="currentPage" :total="total" :currentPage="current" :size="size"></pagenation>
            </div>
        </div>
        <my-footer></my-footer>
    </div>
</template>

<script>
    import MyHeader from "@/components/common/myHeader";
    import MyFooter from "@/components/common/myFooter";
    import getData from "@/api/getData";
    import Pagenation from "@/components/pagenation";
    export default {
        name: "index",
        components: {Pagenation, MyFooter, MyHeader},
        data(){
            return{
                list: [],
                categoryName: '集团动态',
                offset: 0,
                size: 6,
                total: 0,
                current: 1,
            }
        },
        created(){
            this.getList()
        },
        methods:{
            toDetail(id){
                let routeData = this.$router.resolve({
                    name: 'news-detail',
                    query:{
                        id,
                        categoryName: this.categoryName
                    }
                });
                window.open(routeData.href, '_blank');
            },
            tabCurrent(v){
                this.categoryName = v
                this.current = 1
                this.getList()
            },
            currentPage(v){
                this.current = v
                this.getList()
            },
            getList(){
                getData.get('https://nocoapi.kuailework.com/api/v2/tables/mr0ixhr2uoa6v9t/records',{
                    where: '(category,eq,' + this.categoryName + ')~and' + '(show,eq,1)',
                    offset: (this.current - 1) * this.size,
                    limit: this.size,
                    sort: '-releaseDate'
                }).then(res =>{
                    if(res && res.data.list && res.data.list.length > 0){
                        this.list = res.data.list
                    }else{
                        this.list = []
                    }
                    this.total = res.data.pageInfo.totalRows
                    // this.lastPage = Math.ceil(this.total / this.size)
                    // this.setPagenationList()
                })
            }
        }
    }
</script>

<style scoped>
    .banner {
        width: 100%;
        height: 450px;
        position: relative;
        overflow: hidden;
    }
    .banner img {
        left: 50%;
        height: 450px;
        transform: translateX(-50%);
        position: absolute;
    }
    .menu{
        width: 1128px;
        height: 164px;
        border-bottom: 1px solid #EEEEEE;
        display: flex;
        margin: 0 auto;
    }
    .menu .menu_item{
        margin-top: 50px;
        width: 150px;
        position: relative;
        cursor: pointer;
    }
    .menu .menu_item:first-child{
        margin-left: 284px;
    }
    .menu .menu_item:last-child{
        margin-left: 260px;
    }
    .menu .menu_item img{
        width: 55px;
        height: 64px;
        display: block;
        margin: 0 auto;
    }
    .menu .menu_item p{
        margin-top: 15px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 24px;
        color: #333333;
        line-height: 20px;
        text-align: right;
        font-style: normal;
        text-align: center;
    }
    .menu .menu_item.active p{
        font-weight: bold;
    }

    .menu .menu_item:after{
        content: '';
        position: absolute;
        bottom: 0px;
        width: 0;
        height: 4px;
        background: linear-gradient( 270deg, #157AFF 0%, #1478FF 100%);
        border-radius: 2px;
        left: 50%;
        transform: translateX(-50%);
        transition: width 0.3s;
    }
    .menu .menu_item.active:after{
        width: 150px;
    }
    .news_ul{
        width: 1200px;
        margin: 40px auto 0;
        display: flex;
        flex-wrap: wrap;
    }
    .news_ul li{
        width: 350px;
        height: 312px;
        margin-left: 36px;
        margin-bottom: 40px;
        position: relative;
        background: #ffffff;
        box-shadow: 0px 4px 8px 0px rgba(220, 220, 220, 0.5);
        border-radius: 8px;
        overflow: hidden;
        box-sizing: border-box;
        cursor: pointer;
        text-align: left;
    }
    .news_ul li .news_img_box{
        background: #F4F4F4;
        height: 196px;
    }
    .news_ul li .news_img_box img{
        display: block;
        width: 100%;
        height: 100%;
    }
    .news_ul li .targetSearchKey {
        padding: 0 14px;
        width: 100%;
        height: 25px;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 25px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        text-overflow: ellipsis;
        overflow: hidden;
        box-sizing: border-box;
        margin-top: 20px;
    }
    .news_ul li .discription {
        padding: 0 14px;
        width: 100%;
        height: 40px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 20px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        text-overflow: ellipsis;
        overflow: hidden;
        box-sizing: border-box;
        margin-top: 10px;
    }
    .news_ul li:hover img{
        transition: all 0.3s;
        transform: scale(1.1);
    }
    .pagenation_box{
        padding: 30px 0 60px 0;
        text-align: center;
    }
</style>